







































































import { Component, Emit, Model, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from 'vuex-module-decorators';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import ScoringKeyCreator from "@/components/scoring-key/ScoringKeyCreator.vue";
import Modelling from "@/store/modules/Modelling";
import Dialogs from "@/store/modules/Dialogs";
import ScoringKeys from "@/store/modules/ScoringKeys";
import _ from "lodash";

const modellingModule = getModule(Modelling);
const dialogModule = getModule(Dialogs);
const scoringKeysModule = getModule(ScoringKeys)

@Component({
    components: {
        ScoringKeysCreator: ScoringKeyCreator,
        ConfirmationDialog,
        VueSlider
    }
})

export default class ScoringKeyEditor extends Vue {

    @Model('change')
    scoringKey!: any;

    @Prop()
    name!: string;

    @Prop()
    inheritedFromName!: string;

    @Prop()
    loading!: boolean;

    @Prop()
    factorGroupId!: string

    @Prop()
    scoringKeyDefinitions!: any

    private scoringKeysInternal: any[] = [];
    private rerenderKey = 1;

    mounted() {
        this.initializeScoringKeysInternal();
    }

    get selectedResource() {
        return dialogModule.selectedScoringKeyEdit
    }

    get defaultScoringKeyDefinition() {
        if (this.scoringKeyDefinitions && this.factorGroupId) {
            console.log(this.scoringKeyDefinitions)
            return this.scoringKeyDefinitions[this.factorGroupId]
        }
    }

    @Watch("scoringKey")
    private initializeScoringKeysInternal() {
        if (this.scoringKey) {
            this.scoringKeysInternal = JSON.parse(JSON.stringify(this.scoringKey))
                .sort((a: any, b: any) => b.upperLimit - a.upperLimit);
        } else {
            this.scoringKeysInternal = [];
        }
        this.rerenderKey++;
    }

    get factorResources() {
        return modellingModule.workingModelFactorResources;
    }


    // get defaultScoringKeyDefinition() {
    //     if (this.scoringKeyDefinitions && this.factorGroupId && this.viewpointId) {
    //         return this.scoringKeyDefinitions[this.viewpointId][this.factorGroupId]
    //     }
    // }

    @Emit('submit')
    @Emit('change')
    private submit() {
        return Object.assign([], this.scoringKeysInternal);
    }

    @Emit('cancel')
    private cancel() {
        return true;
    }


}
